import { z } from 'zod'

export const clientUsersListFilterParamsSchema = z.object({
  page: z.union([
    z.preprocess((v) => (v === undefined ? 1 : v), z.coerce.number().int().min(1).catch(1)),
    z.number().optional()
  ]),
  size: z.union([
    z.preprocess((v) => (v === undefined ? 10 : v), z.coerce.number().int().min(1).max(100).catch(10)),
    z.number().optional()
  ]),
  searchString: z.union([z.string().catch(''), z.string().optional()]),
  userId: z.string().optional(),
  companyId: z.union([z.number().int().positive().nullable().default(null), z.string().optional()]),
  myCompaniesOnly: z.union([z.boolean().catch(false), z.boolean().optional()])
})

export type ClientUsersListFilterParams = z.infer<typeof clientUsersListFilterParamsSchema>
